import { useLocation, useNavigate } from 'react-router';

export default function useIntercomArticle() {
  const navigate = useNavigate();
  const location = useLocation();

  return (href: string) => navigate(`${location.search}#help=${href}`);
}
